import { render } from "./VehicleListingsTable.vue?vue&type=template&id=63d10c4c"
import script from "./VehicleListingsTable.vue?vue&type=script&lang=js"
export * from "./VehicleListingsTable.vue?vue&type=script&lang=js"

import "./VehicleListingsTable.vue?vue&type=style&index=0&id=63d10c4c&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QIcon,QSkeleton,QTable});
